import { takeLatest } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
import { workerFetchImage } from './workers';
import { fetchImage } from '../actions';

export default function* watchMonitoring(): SagaIterator {
  yield takeLatest(fetchImage, workerFetchImage);
}
